export default "assets/images/background-wine-2808db71.png";